export default __webpack_public_path__ + "static/media/abstract010.95b66643.webp";